/* global React, Icon */
// Reusable iPhone mockup with Telegram chat UI

function PhoneMockup({ variant = "hero" }) {
  const t = (k) => window.i18n.t(k);

  const conversations = {
    hero: [
      { side: "in", text: t("phone.hero.1"), t: "14:32" },
      { side: "out", text: t("phone.hero.2"), t: "14:32" },
      { side: "in", text: t("phone.hero.3"), t: "14:33" },
      {
        side: "out",
        text: t("phone.hero.4"),
        t: "14:33",
        quick: [t("phone.hero.4.q1"), t("phone.hero.4.q2"), t("phone.hero.4.q3")],
      },
      { side: "in", text: t("phone.hero.5"), t: "14:33" },
      { side: "out", text: t("phone.hero.6"), t: "14:33", check: true },
    ],
    case: [
      { side: "in", text: t("phone.case.1"), t: "22:14" },
      { side: "out", text: t("phone.case.2"), t: "22:14" },
      { side: "in", text: t("phone.case.3"), t: "22:15" },
      {
        side: "out",
        text: t("phone.case.4"),
        t: "22:15",
        quick: [t("phone.case.4.q1"), t("phone.case.4.q2")],
      },
    ],
  };

  const msgs = conversations[variant] || conversations.hero;

  return (
    <div className="phone-frame" role="img" aria-label={t("phone.aria.image")}>
      <div className="phone-screen">
        <div className="tg-status">
          <span>9:41</span>
          <span className="icons">
            <svg width="16" height="10" viewBox="0 0 16 10" fill="currentColor" aria-hidden="true">
              <rect x="0" y="6" width="3" height="4" rx="0.5" />
              <rect x="4" y="4" width="3" height="6" rx="0.5" />
              <rect x="8" y="2" width="3" height="8" rx="0.5" />
              <rect x="12" y="0" width="3" height="10" rx="0.5" />
            </svg>
            <svg
              width="14"
              height="10"
              viewBox="0 0 14 10"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.2"
              aria-hidden="true"
            >
              <path
                d="M1 4c2-2 4-3 6-3s4 1 6 3M3 6c1-1 2.5-1.5 4-1.5s3 0.5 4 1.5"
                strokeLinecap="round"
              />
              <circle cx="7" cy="8.5" r="0.7" fill="currentColor" />
            </svg>
            <svg width="22" height="10" viewBox="0 0 22 10" aria-hidden="true">
              <rect
                x="0.5"
                y="1"
                width="18"
                height="8"
                rx="2"
                fill="none"
                stroke="currentColor"
                strokeWidth="1"
              />
              <rect x="2" y="2.5" width="13" height="5" rx="0.8" fill="currentColor" />
              <rect x="19.5" y="3.5" width="1.5" height="3" rx="0.5" fill="currentColor" />
            </svg>
          </span>
        </div>
        <div className="tg-header">
          <div className="avatar">H</div>
          <div>
            <div className="name">
              HealBot
              <span className="tg-verified">✓</span>
            </div>
            <div className="status-line">{t("phone.status.line")}</div>
          </div>
          <div className="right">
            <Icon name="phone" size={18} color="#6AB8E8" stroke={1.8} />
            <Icon name="menu" size={18} color="#6AB8E8" stroke={1.8} />
          </div>
        </div>
        <div className="tg-body">
          <div className="tg-date">{t("phone.tg.date")}</div>
          {msgs.map((m, i) => (
            <div key={i} className={`tg-msg ${m.side}`} style={{ animationDelay: `${i * 0.25}s` }}>
              {m.text}
              <span className={`time ${m.side === "out" ? "out" : ""}`}>
                {m.t}
                {m.check ? " ✓✓" : ""}
              </span>
              {m.quick && (
                <div className="tg-quick">
                  {m.quick.map((q, j) => (
                    <button key={j}>{q}</button>
                  ))}
                </div>
              )}
            </div>
          ))}
          <div
            className="tg-msg in"
            style={{ padding: "10px 14px", animationDelay: `${msgs.length * 0.25}s` }}
          >
            <span className="phone-typing">
              <span></span>
              <span></span>
              <span></span>
            </span>
          </div>
        </div>
        <div className="tg-input-bar">
          <div className="tg-icon-btn">
            <Icon name="plus" size={20} />
          </div>
          <div className="inp">{t("phone.tg.input.placeholder")}</div>
          <div className="tg-icon-btn">
            <Icon name="mic" size={20} />
          </div>
        </div>
      </div>
    </div>
  );
}

window.PhoneMockup = PhoneMockup;
